export default __webpack_public_path__ + "static/media/RTLG4.a711a15d.webp";